import React, { useContext, useEffect, useState } from 'react'
import antMessage from '../../../utils/extend/AntdNotification';
import systemConfig from '../../../config/systematic';
import { Button, Col, DatePicker, Form, Row, Select, Space, Switch, Table } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
const { RangePicker } = DatePicker;

export default function MemberStatistics() {
    let wmService: any = systemConfig.wmService;
    const [form] = Form.useForm();

    const [rows, setRows] = useState<Array<any>>([]);
    const [branchStoreData, setBranchStoreData] = useState<any>();
        const [isLoading, setIsLoading] = useState<boolean>(false)
    
    /** 表头内容 */
    let columnsHead: Array<any> = [
        {
            title: "门店",
            dataIndex: "shopName",
        },
        {
            title: "会员数",
            dataIndex: "counts",
        },



    ]
    useEffect(() => {
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "branchStore",
                apiExtend: 'showListManage'
            }).then(res => {
               
                setBranchStoreData(res.data)
            })

            // fetchApi.GET(bmService,
            //   {
            //     apiId: 'generalData',
            //     apiVariable: 'MembershipStatuses',
            //     apiExtend: 'showLists'
            //   }).then(res => {
            //     if (res.success) {
            //     //   const { caCoMonStatus } = res.data
            //     //   setCaCoMonStatus(caCoMonStatus);
            //     }
            //   })

            // 
        }
        fetchData()

    }, []);


    const onFinish = () => {
        setIsLoading(true)


        form.validateFields()
            .then(async (values: any) => {

               


                fetchApi.GET(wmService, {
                    apiId: "membership",
                    apiExtend: 'membershipStatistics',
                    apiData: {
                        ...values,
                        shopIds: values.brandStoreIds,
                    }
                }).then((res) => {
        setIsLoading(false)

                    if (res.success) {

                        setRows(res.data)
                    }
                }).catch((err) => {
        setIsLoading(false)

                    antMessage("error", JSON.stringify(err))
                })



            })
            .catch((err) => {
        setIsLoading(false)

                antMessage("error", "无法通过数据校验", "请输入所需数据")

            })





    }
    return (
        <>
            {/* <BranchStoreList setDeptData={setDeptData} setSbData={setSbData} form={form}></BranchStoreList> */}
            <Form
                form={form}
                onFinish={onFinish}
            >
                <Row>
                    <Col span={6}>
                        <Form.Item
                            label="门店"
                            name="brandStoreIds"
                        >
                            <Select
                                mode="multiple"
                                fieldNames={{ value: "id", label: "branchStoreName" }}
                                allowClear
                                placeholder="门店"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                                options={branchStoreData}
                            >
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item

                            label="入会日期"
                            name="joinTime"
                        >
                            <RangePicker

                                format="YYYY-MM-DD"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item >
                            <Space>
                               <Button loading={isLoading} htmlType="submit">
                                    统计
                                </Button >
                                {/* <Button onClick={() => DownloadExcel(rows, "makeDept", { date: form.getFieldValue("chooseTime"), sbName, userName, caCoMonStatusName })}>下载EXCEL文件</Button> */}

                                {/* purContrast */}
                            </Space>
                        </Form.Item>
                    </Col>


                </Row>

            </Form>

            <div style={{ marginTop: "20px" }}>
                <Table
                    pagination={false}
                    // rowKey={(record: any, index: any) => {
                    //   console.log(record,index);
                    //   return 1
                    //   // return index
                    // }}
                    columns={columnsHead}
                    dataSource={rows}

                >
                </Table>

            </div>
        </>
    )
}
